import { configureStore } from "@reduxjs/toolkit";
import settingsReducer from "./settings/settingsSlice";

const toolkitReducers = {
  settings: settingsReducer,
  // navLinks: navLinksReducer,
  // auth: authReducer,
  // register: registerReducer,
};
const store = configureStore({
  reducer: toolkitReducers,
});
export default store;
